import React, { useCallback } from "react";
import "./SideBar.css";

import { DtoMenuDefinition } from "../../Dto/menu";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Logo from "../../Assets/images/logo-black.png";

import Menu from "../../Assets/images/menu.svg";
import DashBoard from "../../Assets/images/dashboard.png";
import ManageAccount from "../../Assets/images/menu-icons/manage_accounts_FILL.png";
import TagIcon from "../../Assets/images/menu-icons/assignment.png";
import SelectedTagIcon from "../../Assets/images/menu-icons/assignment_selected.png";
import LocationIcon from "../../Assets/images/menu-icons/location_away_FILL.png";
import SelectedLocationIcon from "../../Assets/images/menu-icons/location_away_selected.png";
import SelectedDashBoard from "../../Assets/images/menu-icons/selected-dashboard.png";
import SelectedUserMenu from "../../Assets/images/menu-icons/manage_accounts_selected.png";
import Header from "../Header/Header";
import { useAppSelector } from "../../Store/hooks";
const drawerWidth = 345;

interface SideBarProps {
  openMenu: boolean;
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MenuArray: DtoMenuDefinition[] = [
  {
    name: "Dashboard",
    redirectTo: "/dashboard",
    permission: "super-admin",
    icon: DashBoard,
    selectedIcon: SelectedDashBoard,
    modules: ["view_users", "manage_users"]
  },
  {
    name: "Roles & Permissions",
    redirectTo: "/roles",
    permission: "admin",
    icon: ManageAccount,
    selectedIcon: SelectedUserMenu,
    modules: ["view_roles", "manage_roles"]
  },
  {
    name: "User Management",
    redirectTo: "/user",
    permission: "admin",
    icon: ManageAccount,
    selectedIcon: SelectedUserMenu,
    modules: ["view_users", "manage_users"]
  },
  {
    name: "Sports",
    redirectTo: "/sports",
    icon: ManageAccount,
    selectedIcon: SelectedUserMenu,
    modules: ["view_sports", "manage_sports"]
  },  
  {
    name: "Posts",
    redirectTo: "/posts",
    icon: ManageAccount,
    selectedIcon: SelectedUserMenu,
    modules: ["view_posts", "manage_posts"]
  },
  {
    name: "Tag",
    redirectTo: "/tag",
    permission: "admin",
    icon: TagIcon,
    selectedIcon: SelectedTagIcon,
    modules: ["view_tags", "manage_tags"]
  },
  {
    name: "Location",
    redirectTo: "/location",
    permission: "admin",
    icon: LocationIcon,
    selectedIcon: SelectedLocationIcon,
    modules: ["view_locations", "manage_locations"]
  },
  {
    name: "Player Management",
    redirectTo: "/player-management",
    permission: "admin",
    icon: ManageAccount,
    selectedIcon: SelectedUserMenu,
    modules: ["manage_users"]
  },
];


export default function SideBar({ openMenu, setOpenMenu }: SideBarProps) {
  let navigate = useNavigate();
  const location = useLocation();
  const permission = useAppSelector((state) => state.auth.permission);

  const toggleDrawer = useCallback(
    () => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setOpenMenu((previousState: boolean) => !previousState);
    },
    [setOpenMenu]
  );

  const getMenuList = useCallback(() => {
    return (
      <>
        <div
          className="list-group"
          onClick={toggleDrawer()}
          onKeyDown={toggleDrawer()}
        >
          {MenuArray.map((menu, index) => (
            <button
              key={index}
              type="button"
              className={
                "list-group-item list-group-item-action " +
                (location.pathname === menu.redirectTo ? "active" : "")
              }
              aria-current="true"
              onClick={() => {
                navigate(menu.redirectTo);
              }}
            >
              {menu.icon}
              {menu.name}
            </button>
          ))}
        </div>
      </>
    );
  }, [location.pathname, navigate, toggleDrawer]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: `calc(100% - ${drawerWidth}px)`,
            ml: `${drawerWidth}px`,
          }}
          style={{ boxShadow: "none" }}
        >
          <Header openMenu={openMenu} setOpenMenu={setOpenMenu} />
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          <div className="side-bar-logo ">
            <img src={Menu} alt="image" width={20} height={20} />
            <img src={Logo} alt="image" className="drawer-logo" onClick={()=>{navigate('/')}} />
          </div>
          <List className="p-0 m-0">
            {MenuArray.map((menu, index) => {
              if(permission.filter((obj:any) => menu?.modules?.includes(obj)).length > 0){
                return (<Link to={menu.redirectTo} className="navigateLink" key={index}>
                  <ListItem
                    key={index}
                    disablePadding
                    className={`${
                      location.pathname === menu.redirectTo &&
                      "selected-dashboard"
                    }`}
                  >
                    <ListItemButton
                      className={`  "medium-font" ${
                        location.pathname === menu.redirectTo
                          ? "selected-menu"
                          : "non-selected-menu"
                      }`}
                    >
                      {/* <ListItemIcon> */}
                      {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                      {/* <img
                        src={`${
                          location.pathname === menu.redirectTo
                            ? menu.selectedIcon
                            : menu.icon
                        }`}
                        alt="FB"
                        className={`drawer-icons`}
                      /> */}
                      {/* </ListItemIcon> */}
                      {/* */}
                      <ListItemText>
                        <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                          {menu.name}
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>)
              }
            })}
          </List>
          <Divider />
        </Drawer>
      </Box>
    </>
  );
}
//
